import { useQuery } from '@tanstack/react-query';

import { integrationsApi } from '../api';
import { CalendlyEventType } from '@demind-inc/core';

interface UseCalendlyEventTypesParams {
  calendlyIntegId?: string;
}

interface UseCalendlyEventTypesQueryParams {
  queryKey: ['lifestack.integration.calendly.eventTypes', { calendlyIntegId: string }];
}

export const useCalendlyEventTypes = ({ calendlyIntegId = '' }: UseCalendlyEventTypesParams) => {
  const calendlyEventTypesQuery = useQuery({
    queryKey: ['lifestack.integration.calendly.eventTypes', { calendlyIntegId }],
    queryFn: ({ queryKey }: UseCalendlyEventTypesQueryParams) => {
      const [, { calendlyIntegId }] = queryKey;

      return integrationsApi
        .getCalendlyEventTypes(calendlyIntegId)
        .then(({ data }) => data as CalendlyEventType[]);
    },
    refetchOnWindowFocus: false,
    enabled: !!calendlyIntegId,
    staleTime: 15000, // 15s
  });

  return {
    ...calendlyEventTypesQuery,
    calendlyEventTypes: calendlyEventTypesQuery.data ?? [],
  };
};
